export default function initCapacityCards() {
    // ==========================================================
    // CAPACITY CARDS ANIMATION
    // ==========================================================

    const capacitySections = document.querySelectorAll("[data-capacity-cards]");

    if (capacitySections.length) {
        const capacityObserver = new IntersectionObserver(
            (entries, observer) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add("is-visible");

                    observer.unobserve(entry.target);
                });
            },
            {
                /**
                 * Pourcentage de la section qui doit être visible
                 * avant de déclencher l'animation.
                 *
                 * 0    = dès qu'elle entre dans l'écran
                 * 0.2  = 20 %
                 * 0.5  = 50 %
                 * 1    = entièrement visible
                 */
                threshold: 0.2,

                /**
                 * Permet de modifier virtuellement le viewport.
                 *
                 * Exemple ci-dessous :
                 * déclenche l'animation lorsque la section arrive
                 * environ 15 % avant le bas du viewport.
                 */
                rootMargin: "0px 0px -35% 0px",
            },
        );

        capacitySections.forEach((section) => {
            capacityObserver.observe(section);
        });
    }
}
